import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface InitiateForgotPasswordRequestModel {
	readonly emailAddress: string;
}

export const useInitiateForgotPassword = () => {
	const http = useHTTP("None");

	const mutationFn: MutationFunction<HTTPResponse, InitiateForgotPasswordRequestModel> = requestModel => {
		return http<undefined, InitiateForgotPasswordRequestModel>({
			method: "POST",
			url: "/auth/forgot/initiate",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
